var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6267 34.8622L58.2318 24.7773V39.7533L49.6267 34.8622Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6267 34.8622L58.2318 24.7773V39.7533L49.6267 34.8622Z",
    stroke: "#8796AF",
    strokeWidth: 0.436803,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8314 34.8467L58.2367 24.7764V39.7524L66.8314 34.8467Z",
    fill: "#E8E8EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8314 34.8467L58.2367 24.7764V39.7524L66.8314 34.8467Z",
    stroke: "#8796AF",
    strokeWidth: 0.436803,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2272 39.7536H63.8433L71.8452 35.1256L62.407 29.625L66.8229 34.8479L58.2272 39.7536Z",
    fill: "#8796AF",
    stroke: "#8796AF",
    strokeWidth: 0.582404,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5515 63.2243L54.5515 63.2242L54.5423 63.23C53.885 63.6446 52.98 63.891 52.0399 63.9309C51.0997 63.9707 50.1808 63.8014 49.4976 63.4441L13.3966 44.5629L13.396 44.5627C12.7082 44.204 12.4754 43.7785 12.4637 43.4508C12.452 43.1219 12.6552 42.6763 13.3121 42.26L26.429 34.3684L26.4291 34.3685L26.4386 34.3625C27.0957 33.9476 28.0008 33.7011 28.9411 33.6614C29.8816 33.6217 30.8007 33.7912 31.4841 34.1485C31.4841 34.1485 31.4841 34.1485 31.4841 34.1485L67.5841 53.0287L67.5845 53.0289C68.2718 53.3875 68.5044 53.813 68.516 54.1406C68.5276 54.4694 68.3245 54.9148 67.6675 55.3305L54.5515 63.2243Z",
    fill: "#E8E8EA",
    stroke: "#E8E8EA",
    strokeWidth: 1.04001
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8197 63.6699C53.3158 64.6184 50.8239 64.7244 49.2566 63.9049L13.1556 45.0237C11.5841 44.2042 11.5352 42.7669 13.0391 41.8174L26.161 33.9228C27.6648 32.9733 30.1577 32.8682 31.7251 33.6877L67.8251 52.5679C69.3955 53.3874 69.4444 54.8247 67.9405 55.7732L54.8197 63.6699Z",
    fill: "#8796AF",
    stroke: "#8796AF",
    strokeWidth: 0.582404,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0308 59.8092C49.5259 60.7587 47.034 60.8637 45.4667 60.0442L9.36669 41.163C7.79522 40.3435 7.74738 38.9062 9.25125 37.9577L22.3731 30.0621C23.877 29.1136 26.3689 29.0075 27.9362 29.827L64.0372 48.7082C65.6087 49.5277 65.6576 50.965 64.1527 51.9135L51.0308 59.8092Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0308 59.8092C49.5259 60.7587 47.034 60.8637 45.4667 60.0442L9.36669 41.163C7.79522 40.3435 7.74738 38.9062 9.25125 37.9577L22.3731 30.0621C23.877 29.1136 26.3689 29.0075 27.9362 29.827L64.0372 48.7082C65.6087 49.5277 65.6576 50.965 64.1527 51.9135L51.0308 59.8092Z",
    stroke: "#8796AF",
    strokeWidth: 0.436803,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2143 63.8574L64.3373 55.9617C65.0934 55.4833 65.4553 54.8843 65.4314 54.2998L65.2483 50.2511C65.2722 50.8355 64.9103 51.4346 64.1532 51.913L51.0323 59.8097C49.5274 60.7582 47.0355 60.8632 45.4682 60.0437L9.36823 41.1625C8.58822 40.7548 8.18261 40.1953 8.15869 39.6191L8.34173 43.6679C8.36565 44.243 8.77022 44.8035 9.55127 45.2102L45.6534 64.0924C47.2238 64.9119 49.7115 64.8058 51.2164 63.8574",
    fill: "#E8E8EA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2143 63.8574L64.3373 55.9617C65.0934 55.4833 65.4553 54.8843 65.4314 54.2998L65.2483 50.2511C65.2722 50.8355 64.9103 51.4346 64.1532 51.913L51.0323 59.8097C49.5274 60.7582 47.0355 60.8632 45.4682 60.0437L9.36823 41.1625C8.58822 40.7548 8.18261 40.1953 8.15869 39.6191L8.34173 43.6679C8.36565 44.243 8.77022 44.8035 9.55127 45.2102L45.6534 64.0924C47.2238 64.9119 49.7115 64.8058 51.2164 63.8574H51.2143Z",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4949 36.2611L19.9732 33.5207C20.3572 33.2853 20.7956 33.1532 21.2458 33.1374C21.6959 33.1215 22.1425 33.2224 22.5421 33.4302C23.0392 33.6881 23.0631 34.3828 22.5858 34.6751L18.1075 37.4165C17.3274 37.8949 16.3477 37.9282 15.5386 37.507C15.4257 37.4489 15.3303 37.3617 15.2623 37.2544C15.1943 37.1472 15.1561 37.0238 15.1517 36.8968C15.1472 36.7699 15.1767 36.6441 15.237 36.5324C15.2974 36.4206 15.3864 36.327 15.4949 36.2611Z",
    fill: "#8796AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4949 36.2611L19.9732 33.5207C20.3572 33.2853 20.7956 33.1532 21.2458 33.1374C21.6959 33.1215 22.1425 33.2224 22.5421 33.4302C23.0392 33.6881 23.0631 34.3828 22.5858 34.6751L18.1075 37.4165C17.3274 37.8949 16.3477 37.9282 15.5386 37.507C15.4257 37.4489 15.3303 37.3617 15.2623 37.2544C15.1943 37.1472 15.1561 37.0238 15.1517 36.8968C15.1472 36.7699 15.1767 36.6441 15.237 36.5324C15.2974 36.4206 15.3864 36.327 15.4949 36.2611Z",
    stroke: "#8796AF",
    strokeWidth: 0.582404,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.202 44.7412L13.3065 45.3205M16.6263 47.0313L20.7822 49.2007M22.026 49.7384L26.1809 51.913",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8099 33.9085C22.0033 34.0187 22.0033 34.1955 21.8099 34.311C21.7027 34.3659 21.584 34.3946 21.4635 34.3946C21.3431 34.3946 21.2244 34.3659 21.1172 34.311C20.9248 34.2007 20.9248 34.0187 21.1172 33.9085C21.2246 33.8544 21.3432 33.8262 21.4635 33.8262C21.5838 33.8262 21.7024 33.8544 21.8099 33.9085Z",
    fill: "#25C277"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.758 66.0002C31.4153 66.0002 33.5691 64.9384 33.5691 63.629C33.5691 62.3186 31.4153 61.2578 28.758 61.2578C26.1008 61.2578 23.9469 62.3186 23.9469 63.629C23.9469 64.9394 26.1008 66.0002 28.758 66.0002Z",
    fill: "#8796AF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4142 65.6829C29.6539 65.6829 32.2799 63.0725 32.2799 59.8527C32.2799 56.6329 29.6539 54.0225 26.4142 54.0225C23.1735 54.0225 20.5475 56.6329 20.5475 59.8527C20.5475 63.0725 23.1735 65.684 26.4132 65.684",
    fill: "url(#paint0_radial_18061_81614)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4142 65.6829C29.6539 65.6829 32.2799 63.0725 32.2799 59.8527C32.2799 56.6329 29.6539 54.0225 26.4142 54.0225C23.1735 54.0225 20.5475 56.6329 20.5475 59.8527C20.5475 63.0725 23.1735 65.684 26.4132 65.684",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4901 51.0125L50.8889 49.0521L50.893 46.0049L47.4995 47.9705L47.4901 51.0125Z",
    fill: "#A9B1C1",
    stroke: "#8796AF",
    strokeWidth: 0.436803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2524 26.1807L32.6102 14.333C31.9311 13.944 31.3185 13.9066 30.8744 14.1645L27.4767 16.1301C27.9197 15.8701 28.5375 15.9086 29.2114 16.2965L49.8589 28.1452C51.2088 28.9169 52.2977 30.7951 52.2925 32.3281L52.2499 47.9083C52.2499 48.6748 51.9753 49.2115 51.5364 49.4652L54.9352 47.5017C55.373 47.2469 55.6424 46.7113 55.6486 45.9438L55.6913 30.3635C55.6913 28.8254 54.6066 26.9523 53.2577 26.1807H53.2524Z",
    fill: "#E8E8EA",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8648 28.1395C51.2147 28.9112 52.3036 30.7894 52.2984 32.3224L52.2558 47.9026C52.2558 49.4418 51.1565 50.0637 49.8066 49.2879L47.5029 47.965L47.4925 51.008L44.8363 46.432L29.1602 37.435C27.8102 36.6633 26.7203 34.7851 26.7255 33.2469L26.7692 17.6667C26.7692 16.1285 27.8674 15.5108 29.2174 16.2825L49.8648 28.1301V28.1395Z",
    fill: "white",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1731 32.3041L47.7471 33.8183C48.4262 34.2104 48.9764 35.1599 48.9764 35.9358C48.9764 36.7158 48.4221 37.0278 47.7419 36.6346L36.9632 30.143C36.2841 29.7498 35.7339 28.8066 35.7339 28.0297C35.7339 27.2497 36.2882 26.9335 36.9684 27.3256L43.2501 31.1497",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7505 39.5676C48.4297 39.9607 48.9798 40.9092 48.9798 41.6851C48.9798 42.4661 48.4245 42.777 47.7453 42.385L42.6066 39.3856C41.9265 38.9925 41.3773 38.0492 41.3773 37.2723C41.3773 36.4923 41.9316 36.1751 42.6118 36.5683L47.7505 39.5676Z",
    fill: "#25C277"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4173 41.1184C44.4361 34.842 39.9973 27.2094 34.506 24.0572C30.8763 21.973 27.6897 22.3755 25.9446 24.6989L25.9207 32.7381C25.9207 34.2773 27.0054 36.1545 28.3543 36.9262L43.3804 45.5498C44.0357 44.41 44.4121 42.9197 44.4173 41.1236V41.1184Z",
    fill: "#8796AF",
    stroke: "#8796AF",
    strokeWidth: 0.582404,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9595 56.9394L59.7716 52.8418",
    stroke: "#8796AF",
    strokeWidth: 0.436803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4669 22.6065C29.637 20.9831 27.0775 20.8344 25.2263 21.9025L21.8275 23.867C23.6787 22.7989 26.2382 22.9477 29.0681 24.5711C34.6894 27.7951 39.2291 35.6097 39.2104 42.0306C39.201 45.2161 38.0684 47.4584 36.2411 48.5171L39.6399 46.5525C41.4672 45.499 42.5998 43.2516 42.6091 40.0661C42.6299 33.6451 38.0871 25.8305 32.4669 22.6065Z",
    fill: "#E8E8EA",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0755 24.5659C34.6958 27.7899 39.2365 35.6044 39.2167 42.0244C39.198 48.4443 34.6282 51.0307 29.0069 47.8067C27.1796 46.7574 25.4739 45.2203 23.994 43.4086L18.9218 42.0192L20.3009 37.1322C19.3898 34.866 18.8646 32.524 18.8688 30.3483C18.8886 23.9284 23.4584 21.3419 29.0797 24.5659H29.0755Z",
    fill: "white",
    stroke: "#8796AF",
    strokeWidth: 0.486724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0425 43.0788C34.2547 42.5276 34.2547 41.9525 34.1923 41.7892C34.1299 41.6363 33.9603 41.4689 33.7097 41.1808C33.4601 40.8937 32.2204 39.4804 31.9895 39.2547C31.8876 39.159 31.8013 39.0727 31.7191 39.0259C31.613 38.9635 31.5163 38.9635 31.4248 39.0727C31.2563 39.2641 30.7748 39.6385 30.6198 39.7383C30.5377 39.8007 30.4513 39.8111 30.3494 39.7487C30.246 39.6796 30.1534 39.5955 30.0748 39.4991C29.8252 39.2121 29.0099 38.4404 28.051 36.9074C27.5048 36.0179 27.0384 35.0817 26.6573 34.1098C26.5128 33.7406 26.6428 33.6543 26.7686 33.5826C26.8841 33.5202 27.0234 33.3953 27.1493 33.2997C27.2741 33.1988 27.3178 33.1083 27.3999 32.9596C27.4914 32.8202 27.4436 32.6237 27.3802 32.4469C27.3178 32.2649 26.831 30.5593 26.6095 29.8646C26.4213 29.2801 26.2237 29.1501 26.0448 29.045C25.952 28.9845 25.8573 28.9269 25.7609 28.8724L25.5633 28.758C25.3948 28.6623 25.1244 28.576 24.8883 28.7289C24.6616 28.887 24.0063 29.2073 24.0063 30.6258C24.0063 32.0444 24.8976 33.9268 25.0235 34.1857C25.1483 34.4499 26.7582 38.378 29.3188 41.004C30.7311 42.4558 31.3967 42.9633 31.82 43.2077C32.0322 43.3273 32.1871 43.3845 32.341 43.4573C32.8038 43.6768 33.8303 43.6196 34.0425 43.0684",
    fill: "#25C277"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18061_81614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2677 57.208) scale(14.891 14.7997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A9B1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8796AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastCreate);
export default __webpack_public_path__ + "static/media/broadcast-create.aafb85612cd02fc7bf43050c5e50ec65.svg";
export { ForwardRef as ReactComponent };